import { CardElement } from '@stripe/react-stripe-js';
import type { StripeCardElementChangeEvent } from '@stripe/stripe-js';
import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Icon from '~/components/Icon/Icon';
import Select from '~/components/Select/Select';

import { AnalyticsEvent, analyticsService } from '~/services/analytics';
import { cartStore, checkoutStore, mainStore, orderStore } from '~/stores';

const StripeCardPayment = () => {
  const { t } = useTranslation();
  const [isCardEmpty, setIsCardEmpty] = useState('');
  const handleAgreeChange = () =>
    checkoutStore.setAgreeSaveCard(!checkoutStore.agreeSaveCard);
  const handleNewCard = (flag: boolean) => checkoutStore.setIsAddNewCard(flag);
  const paymentsChange = (val: string) => {
    checkoutStore.setPaymentsMethodId(val);
    checkoutStore.setIsDisabled(false);
    orderStore.setDefaultPayment(val);
    analyticsService.track(AnalyticsEvent.PURCHASE_PAYMENT_METHOD_FILLED_IN, {
      cart_id: undefined,
      payment_method: 'card',
      type: 'existing',
    });
    analyticsService.track(AnalyticsEvent.ADD_PAYMENT_INFO, {
      currency: orderStore.currency.toUpperCase(),
      payment_type: 'credit card',
      value: mainStore.toFloat(cartStore.finalPrice),
      items: cartStore.cartForFirebase,
      coupon: cartStore.promocode.value,
    });
  };

  const handleChange = (e: StripeCardElementChangeEvent) => {
    setIsCardEmpty(e.empty ? '' : 'true');
    checkoutStore.setIsDisabled(!e.complete);
    checkoutStore.setError(e.error ? e.error.message : '');
    checkoutStore.setIsCardValid(e.complete);
    checkoutStore.setIsCardAdded(!e.empty);

    if (e.complete) {
      analyticsService.track(AnalyticsEvent.PURCHASE_PAYMENT_METHOD_FILLED_IN, {
        cart_id: undefined,
        payment_method: 'card',
        type: 'new',
      });
      analyticsService.track(AnalyticsEvent.ADD_PAYMENT_INFO, {
        currency: orderStore.currency.toUpperCase(),
        payment_type: 'credit card',
        value: mainStore.toFloat(cartStore.finalPrice),
        items: cartStore.cartForFirebase,
        coupon: cartStore.promocode.value,
      });
    }
  };

  return (
    <>
      {Array.isArray(checkoutStore.payments) &&
      checkoutStore.payments.length > 0 &&
      !checkoutStore.isAddNewCard ? (
        <>
          <div className="panel-section__content-payment-add-title-container">
            <p className="panel-section__content-payment-add-title">
              {t('paymentDetails')}
            </p>
            <button
              className="button _no-padding _no-color"
              onClick={() => handleNewCard(true)}
            >
              <Icon type="card-add" size={24} />
              {t('addNewCard')}
            </button>
          </div>
          <Select
            attributeName="select-card"
            className="panel-section__content-payment-add-select"
            // @ts-expect-error FIXME: migrate to noUncheckedIndexedAccess: true
            initialValue={checkoutStore.payments[0].text}
            data={checkoutStore.payments}
            onChange={paymentsChange}
          />
          {checkoutStore.error && (
            <div className="alert _error mt-10 z-auto">
              {checkoutStore.error}
            </div>
          )}
        </>
      ) : (
        <>
          <div className="panel-section__content-payment-add-title-container">
            <p className="panel-section__content-payment-add-title">
              {t('paymentDetails')}
            </p>
            {checkoutStore.isAddNewCard &&
              Array.isArray(checkoutStore.payments) &&
              checkoutStore.payments.length && (
                <button
                  data-button="choose-card"
                  className="button _no-padding _no-color"
                  onClick={() => handleNewCard(false)}
                >
                  <Icon type="cards" size={24} />
                  {t('chooseCardInList')}
                </button>
              )}
          </div>
          <div
            id="stripe-card-input-container"
            className={classes([
              'panel-section__content-payment-add-card-form',
              (checkoutStore.error || !isCardEmpty) && '_error',
            ])}
          >
            <CardElement
              className="z-3 position-relative"
              options={checkoutStore.cardStyle}
              onChange={handleChange}
            />
            <input className="card-validation" value={isCardEmpty} readOnly />
          </div>
          {checkoutStore.error && (
            <div className="card-alert">{checkoutStore.error}</div>
          )}
          <label className="control__checkbox">
            <input
              data-checkbox="remember-me"
              type="checkbox"
              className="control__checkbox-input"
              checked={checkoutStore.agreeSaveCard}
              onChange={handleAgreeChange}
            />
            <span className="control__checkbox-mark" />
            {t('phrases:rememberMyCard')}
          </label>
        </>
      )}
    </>
  );
};

export default observer(StripeCardPayment);
